import React, { useContext } from "react";

//styling
import "./clusterRow.css";

//global state
import { StateContext } from "../../AppStateContext";

//Material UI stuff
import TableCell from "@material-ui/core/TableCell";

const ClusterRowInfoTier = ({ clusterInfo }) => {
  //consume global state
  const state = useContext(StateContext);

  return (
    <TableCell
      align="left"
      style={{
        borderBottom:
          state.theme === "dark" ? "1px solid #122742" : "1px solid #eaeaea",
      }}
    >
      <p
        styles={{ margin: "0", width: "fit-content" }}
        className={
          state.theme === "dark"
            ? "__tableCell __tableCellDark"
            : "__tableCell __tableCellLight"
        }
      >
        {clusterInfo.data.configuration.tier}
      </p>
    </TableCell>
  );
};

export default ClusterRowInfoTier;
